<template lang="pug">
.tw-white-card(v-if='buyer')
	v-form(ref='form' @submit.prevent)
		div.tw-grid.tw-grid-cols-3.tw-gap-2(class="emd:tw-grid-cols-1")
			v-text-field(
				v-model="buyer.name"
				:rules="nameRules"
				:label="$t('form_labels.name', 'Nome') + ' *'"
				:error-messages="fieldErrorMessages && fieldErrorMessages.name"
				:focused='true'
				:disabled="!isTicketPurchase"
			)
			v-text-field(
				v-model="buyer.surname"
				:rules="surnameRules"
				:label="$t('form_labels.surname', 'Cognome') + ' *'"
				:error-messages="fieldErrorMessages && fieldErrorMessages.surname"
				:disabled="!isTicketPurchase"
			)
			div.tw-flex(class="md:tw-basis-1/3 emd:tw-w-full")
				v-text-field.phone-prefix(
					class="tw-border-r-0"
					v-model="buyer.phonePrefix"
					:disabled="!isTicketPurchase"
				)
				v-text-field.phone-number.tw-grow-1(
					v-model="buyer.phoneNumber"
					:label="$t('form_labels.phone', 'Numero cellulare')+ '*'"
					:hint="'- ' + $t('form_labels.phone_warning', 'La notifica via sms è possibile solo per numeri italiani.') + ' -'"
					persistent-hint
					:error-messages="prefixWarning"
					:disabled="!isTicketPurchase"
				)
			v-text-field(
				v-model="buyer.email"
				:rules="emailRules"
				:label="$t('postsale.search_travel.email', 'Email')+ '*'"
				:error-messages="fieldErrorMessages && fieldErrorMessages.email"
				:disabled="!isTicketPurchase"
			)
		div.twc-flex-row-center.tw-gap-4.tw-justify-start(v-if="isTicketPurchase" class="emd:tw-flex-col")
			div *{{$t('sale.travellers_data.required_data', 'Dati obbligatori')}}
			div
				v-switch(
					:model-value="bookingStore.buyerIspassenger"
					@click="updatepassengerData"
					color="primary-darken-1"
					:label="$t('form_labels.buyer_is_first_passenger', 'L\\'acquirente corrisponde al passeggero 1')"
					hide-details
				)
</template>


<script setup>
import { useBookingStore } from "@/stores/booking";
import {computed, ref, watch} from "vue";
import {useI18n} from "vue-i18n";


const i18n = useI18n();
const props = defineProps({
	buyer: Object,
	isTicketPurchase: Boolean
});
const form = ref(null);
const bookingStore = useBookingStore();
// NON VA BENE, GLI ERRORI DI VALIDAZIONE SONO PER I PASSEGGERI NON PER IL BUYER
const fieldErrorMessages = computed(() => {
	if(!bookingStore.buyerIspassenger) return {};
	if(!bookingStore.travellerParameterErrors) return {};
	if(!bookingStore.travellerParameterErrors[props.buyer.xmlId]) return {};
	const result = {};
	for (const key in bookingStore.travellerParameterErrors[props.buyer.xmlId]) {
		if (!Object.hasOwnProperty.call(bookingStore.travellerParameterErrors[props.buyer.xmlId], key)) continue;
		const element = bookingStore.travellerParameterErrors[props.buyer.xmlId][key];
		if(!element.validationMessages || element.validationMessages.length == 0) continue;
		result[key] = [element.validationMessages[0]];
	}
	return result;
});
const nameRules = [
	v => !!v || i18n.t('rules.name', 'Nome obbligatorio'),
];
const surnameRules = [
	v => !!v || i18n.t('rules.surname', 'Cognome obbligatorio'),
];
const emailRules = [
	v => !!v || i18n.t('common.required_field', 'Campo obbligatorio'),
	v => (!v || /.+@.+\..+/.test(v)) || i18n.t('rules.email', 'Inserire una email valida'),
];
const prefixWarning = computed(() => {
	return '+39' == props.buyer.phoneNumber ? '' : i18n.t('form_labels.phone_warning', 'La notifica via sms è possibile solo per numeri italiani.');
});


defineExpose({
	form
});


watch(() => props.buyer.name, () => updatePassenger());
watch(() => props.buyer.surname, () => updatePassenger());
watch(() => props.buyer.phoneNumber, () => updatePassenger());
watch(() => props.buyer.email, () => updatePassenger());

function updatePassenger () {
	if (bookingStore.buyerIspassenger) {
		Object.assign(bookingStore.passengers[0].data, {
			name: bookingStore.buyer.data.name,
			surname: bookingStore.buyer.data.surname,
			phonePrefix: bookingStore.buyer.data.phonePrefix,
			phoneNumber: bookingStore.buyer.data.phoneNumber,
			email: bookingStore.buyer.data.email
		});
	}
}

function updatepassengerData () {
	bookingStore.buyerIspassenger = !bookingStore.buyerIspassenger

	updatePassenger();
}
</script>
<style>
.phone-prefix {
	margin-top: 25px;
}
.phone-prefix .v-input__control .v-field.v-theme--forexchange {
	border-right: none;
	border-top-right-radius: 0;
	border-bottom-right-radius: 0;
}
.phone-number .v-input__control .v-field.v-theme--forexchange {
	border-top-left-radius: 0;
	border-bottom-left-radius: 0;
}
.phone-number.default .v-input__details {
	color: green !important;
}
.phone-number.danger .v-input__details .v-messages__message {
	color: red;
}
</style>
